import Animation from './animation'
import * as d3 from 'd3-selection'
import * as scale from 'd3-scale'
import * as shape from 'd3-shape'
import { interpolatePath } from 'd3-interpolate-path'

class BasicAnimation extends Animation {

  match () {
    return true
  }

  animate (serie, enter, selection, merged, exit) {
    let self = this

    selection.selectAll('path.line')
             .data([serie.points, serie.points])

    let lines = merged.selectAll('path.line')
                      .call(this._setStroke, serie.color)
                      .attr('class', (d, i) => {
                        let clazzes = ['line', serie.color || '']
                        if (i == 0) {
                          // First line,
                          clazzes.push('outer-line')
                        }
                        return clazzes.filter(Boolean).join(' ')
                      })
                      .tween('path', function (d) {
                        let interpolater = interpolatePath(this.getAttribute('d'), self.line(d))
                        return t => {
                          this.setAttribute('d', interpolater(t))
                        }
                      })

    lines.filter((d, i) => i > 0)
         .style('opacity', serie.opacity || 1)

    let fills = selection.selectAll('path.fill')
                         .data(this._fillData(serie), d => d.type)

    fills.exit()
         .transition()
         .duration(merged.duration())
         .attr('d', d => this.flatArea(d.points))
         .remove()

    fills.enter().call(this._insertFills, merged)

    merged.selectAll('path.fill')
          .attr('class', d => `fill ${d.color}`)
          .select(function (d) {
            d3.select(this).call(self._setFill, d.color)
            return this
          })
          .tween('path', function (d) {
            let fill = this.dataset.fill
              , maxX = self.scale(d.points[d.points.length - 1][0])
              , interpolater = interpolatePath(this.getAttribute('d'), self.fill[fill](d.points), (a, b) => {
                return a.x == b.x && a.x == maxX
              })

            return t => {
              this.setAttribute('d', interpolater(t))
            }
          })
  }

}

export default BasicAnimation
